import React from 'react';
import classnames from 'classnames';
import { ParentSize } from '@visx/responsive';
import { Redirect } from 'react-router-dom';

import { Icon } from 'js/components';
import { faComments } from '@fortawesome/pro-regular-svg-icons';

import Question from '../Question';
import VoteTally from '../VoteTally';
import VoteTallyCount from 'js/containers/VoteTallyCount';
import CommentWordCloud from '../CommentWordCloud';
import ParticipantList from './ParticipantList';
import { TILE_PRESENTATION, liveTilePresentation } from '../../utilities';

function commentResponseCount(responses = []) {
  return responses.filter(
    (r) => r && (r.is_na || (r.value != null && r.value !== ''))
  ).length;
}

const HostQuestion = (props) => {
  const { liveAssessmentData, question, participants } = props;
  const isCompletion =
    question && liveTilePresentation(question) === TILE_PRESENTATION.COMPLETION;
  const responses = question?.responses || [];
  const responseCount = commentResponseCount(responses);

  const voteTallyClasses = {
    'vote-tally-wrapper': true,
    'show-results':
      question &&
      question.reveal_results_on &&
      question.reveal_results_on <= Date.now(),
  };

  return !question ? (
    <Redirect to="host/kickoff" />
  ) : (
    <div className="container-fluid">
      <div className="row">
        <div className="col col-12 col-md-3 order-md-9">
          <div className="sidebar-item">
            <h4>Responses</h4>
            {isCompletion ? (
              <div className="comment-response-count">
                <span className="comment-response-count-value">
                  {responseCount} <Icon icon={faComments} />
                </span>
              </div>
            ) : (
              <div className={classnames(voteTallyClasses)}>
                <div style={{ position: 'relative' }}>
                  <VoteTally
                    responses={question.responses}
                    type="horizontal-bar"
                    question={question}
                  />
                  <VoteTallyCount
                    question={question}
                    responses={question.responses}
                  />
                </div>
              </div>
            )}
          </div>
          <div className="sidebar-item">
            <ParticipantList
              participants={participants}
              hostId={liveAssessmentData.host_id}
            />
          </div>
        </div>
        <div className="col col-12 col-md-9 order-md-1">
          <Question {...props} isMarker={false} />
          {isCompletion ? (
            <div className="host-comment-word-cloud">
              <ParentSize debounceTime={50}>
                {({ width, height }) =>
                  width > 0 && height > 0 ? (
                    <CommentWordCloud
                      responses={responses}
                      width={width}
                      height={height}
                    />
                  ) : null
                }
              </ParentSize>
              {responseCount === 0 ? (
                <div className="host-comment-word-cloud-empty">No results</div>
              ) : null}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default HostQuestion;
